import { useState, useEffect, useContext } from 'react';
import { ClientContext } from '../../../../contexts/clientProvider';
import LoadingSpinner from '../../../Loader/load';
import DataTable from '../../../Table';
import { FaturadorContext } from '../../../../contexts/faturadorProvider';
import FilterDate from '../filterDate';
import { BiX } from "react-icons/bi";
import BaseSelect from '../../../General/FormsComp/Select/BaseSelect';

const Anexos = () => {
  const { clientes, setIdCliente } = useContext(ClientContext);
  const { patrimonios, loading, toBrl, calculateTotalByGrupoValor, clienteSelecionado, setClienteSelecionado, filterDates, setFilterDates } = useContext(FaturadorContext);
  const [clients, setClients] = useState([]);
  const [groupedPatrimonios, setGroupedPatrimonios] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [checkUpdate, setCheckUpdate] = useState(false);
  const [selectedClient, setSelectedClient] = useState('');
  const [totalGrupoValor, setTotalGrupoValor] = useState(0);

  const headers = [
    { label: "Anexo", key: "nome_do_anexo", sortable: false, width: "w-64" },
    { label: "Valor", key: "valor_cobrado", sortable: true, width: "w-32", type: "money" },
  ];

  useEffect(() => {
    if (patrimonios && patrimonios.length > 0) {
      // Filtrar patrimonios para excluir anexo "ESTOQUE"
      const patrimoniosFiltered = patrimonios.filter(pat => 
        pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque"
      );
      
      let newPats = patrimoniosFiltered.map((pat) => {
        if(!pat.produto){
          pat.produto = `${pat.marca_nome} ${pat.modelo_nome}`;
        }
        if(pat.data_implantacao){
          pat.data_implantacao = formatDate(pat.data_implantacao.split('T')[0]);
          return pat;
        }
        return pat;
      });
      
      // Agrupar por anexo_id usando grupo_valor
      const groupsMap = new Map();
      
      for (const pat of newPats) {
        // Usar anexo_id como chave principal, nome_do_anexo como fallback
        const anexoKey = pat.anexo_id || pat.id_anexo || pat.nome_do_anexo;
        const anexoNome = pat.nome_do_anexo;
        
        if (!anexoKey || !anexoNome) continue;
        
        if (!groupsMap.has(anexoKey)) {
          groupsMap.set(anexoKey, {
            nome: anexoNome,
            patrimonios: []
          });
        }
        groupsMap.get(anexoKey).patrimonios.push(pat);
      }

      // Calcular totais por anexo usando a função do provider
      const groupedArray = Array.from(groupsMap.entries()).map(([anexoKey, data]) => {
        const total = calculateTotalByGrupoValor(data.patrimonios);
        return {
          nome_do_anexo: data.nome,
          valor_cobrado: toBrl(total),
        };
      });
      
      setGroupedPatrimonios(groupedArray);
      
      // Calcular total geral
      const totalGeral = calculateTotalByGrupoValor(newPats);
      setTotalGrupoValor(totalGeral);
    } else {
      setGroupedPatrimonios([]);
      setTotalGrupoValor(0);
    }
  }, [patrimonios, calculateTotalByGrupoValor]);
  

  useEffect(() => {
    setClients(clientes ? clientes : []);
  }, [clientes]);

  const handleSelectClient = (e) => {
    const id = e.target.value;
    setSelectedClient(id);
    const selectedClient = clients.find((client) => client.id === parseInt(id));

    if (selectedClient) {
      setIdCliente(id);
      setClienteSelecionado(selectedClient.nome);
    } else {
      setClienteSelecionado('');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const eraseFilter = () => {
    setFilterDates({ dataInicio: null, dataFim: null, checkUpdate: false });
    const client = clientes.find((client) => client.nome === clienteSelecionado);
    setIdCliente(client.id);
  }

  const handleDateModal = () => {
    setFilterModal(!filterModal);
  };

  return (
    <>
      <div className="mb-6">
        <BaseSelect
          label="Cliente"
          name="cliente"
          value={selectedClient}
          onChange={handleSelectClient}
          options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
          placeholder="Selecione o cliente"
          valueKey="id"
          labelKey="nome"
        />
      </div>
      {
        clienteSelecionado && (
          <>
                      {!filterDates.dataInicio && !filterDates.dataFim ? (
            <div className="mb-4">
              <button 
                onClick={() => setFilterModal(true)}
                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-vox-blue-600 to-vox-blue-700 hover:from-vox-blue-700 hover:to-vox-blue-800 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
                </svg>
                Filtrar por data de implantação
              </button>
            </div>
          ) : (
                          <div className="mb-4 p-4 bg-gradient-to-r from-vox-green-50 to-vox-blue-50 dark:from-vox-green-900/20 dark:to-vox-blue-900/20 border border-vox-green-200 dark:border-vox-green-700 rounded-xl shadow-sm">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex flex-wrap items-center gap-4 text-sm">
                  <span className="flex items-center gap-2">
                    <span className="font-medium text-vox-green-700 dark:text-vox-green-300">Data Inicial:</span>
                    <span className="px-2 py-1 bg-white dark:bg-gray-700 rounded-md border">{formatDate(filterDates.dataInicio)}</span>
                  </span>
                  <span className="flex items-center gap-2">
                    <span className="font-medium text-vox-green-700 dark:text-vox-green-300">Data Final:</span>
                    <span className="px-2 py-1 bg-white dark:bg-gray-700 rounded-md border">{formatDate(filterDates.dataFim)}</span>
                  </span>
                </div>
                <button 
                  onClick={eraseFilter}
                  className="p-2 text-vox-red-600 hover:text-vox-red-700 hover:bg-vox-red-50 dark:hover:bg-vox-red-900/20 rounded-lg transition-colors duration-200"
                  title="Limpar filtros"
                >
                  <BiX className="w-5 h-5" />
                </button>
              </div>
            </div>
            )}
          </>
        )
      }
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-gradient-to-r from-vox-blue-50 to-vox-blue-100 dark:from-vox-blue-900/20 dark:to-vox-blue-800/20 border border-vox-blue-200 dark:border-vox-blue-700 rounded-xl p-4 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-vox-blue-500 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 00-2 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-vox-blue-600 dark:text-vox-blue-400">Aparelhos Contados</p>
              <p className="text-2xl font-bold text-vox-blue-800 dark:text-vox-blue-300">{patrimonios.filter(pat => pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque").length}</p>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-r from-vox-green-50 to-vox-green-100 dark:from-vox-green-900/20 dark:to-vox-green-800/20 border border-vox-green-200 dark:border-vox-green-700 rounded-xl p-4 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-vox-green-500 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-vox-green-600 dark:text-vox-green-400">Valor Total</p>
              <p className="text-2xl font-bold text-vox-green-800 dark:text-vox-green-300">{toBrl(totalGrupoValor)}</p>
            </div>
          </div>
        </div>
      </div>
      
      {loading && <LoadingSpinner />}
      {groupedPatrimonios && <DataTable headers={headers} data={groupedPatrimonios} itemsPerPage={5} exportButton={true} docTitle={`Anexos do cliente ${clienteSelecionado}`} footerValues={["Valor Total", toBrl(totalGrupoValor)]}/>}
      {filterModal && <FilterDate filterDates={filterDates} setFilterDates={setFilterDates} closeModal={handleDateModal} checkUpdate={checkUpdate} setCheckUpdate={setCheckUpdate} />}
    </>
  );
};

export default Anexos;
